

window.addEventListener("load", function () {
    // Xử lý click vào label để check input radio/checkbox liền kề
    var form = document.getElementById('pm__profile-form');
    if (form) {
        var labels = form.querySelectorAll('label');
        
        labels.forEach(function(label) {
            label.addEventListener('click', function(e) {
                // Tìm input radio hoặc checkbox liền kề trong cùng một .row
                var row = label.closest('.row');
                if (row) {
                    var input = row.querySelector('input[type="radio"], input[type="checkbox"]');
                    if (input) {                        
                        // Nếu input là radio, uncheck các radio khác cùng name trước rồi check
                        if (input.type === 'radio') {
                            var radios = form.querySelectorAll('input[type="radio"][name="' + input.name + '"]');
                            radios.forEach(function(radio) {
                                radio.checked = false;
                            });
                            // Check input radio
                            input.checked = true;
                        } 
                        // Nếu input là checkbox, toggle giá trị
                        else if (input.type === 'checkbox') {
                            //var checkboxs = form.querySelectorAll('input[type="checkbox"][name="' + input.name + '"]');
                            input.checked = !input.checked;
                            //console.log("checkboxs", checkboxs.checked);
                            
                        }
                        
                        // Trigger change event để các handler khác có thể lắng nghe
                        var event = new Event('change', { bubbles: true });
                        input.dispatchEvent(event);
                    }
                }
            });
        });

        // Trong mỗi .check-special: nếu chọn input value="none"
        // thì bỏ chọn các checkbox còn lại trong cùng nhóm.
        var specialGroups = form.querySelectorAll('.check-special');
        specialGroups.forEach(function(group) {
            group.addEventListener('change', function(event) {
                var target = event.target;
                if (!target || target.tagName !== 'INPUT' || target.type !== 'checkbox') {
                    return;
                }

                if (target.value === 'none' && target.checked) {
                    var otherCheckedInputs = group.querySelectorAll('input[type="checkbox"]:checked:not([value="none"])');
                    otherCheckedInputs.forEach(function(input) {
                        input.checked = false;
                    });
                    return;
                }

                if (target.value !== 'none' && target.checked) {
                    var noneInput = group.querySelector('input[type="checkbox"][value="none"]');
                    if (noneInput) {
                        noneInput.checked = false;
                    }
                }
            });
        });
        
    }
});
